// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__21_-B","author":"Table_author__1E_Co","authorImage":"Table_authorImage__12HKJ","unreadRow":"Table_unreadRow__1aBEj"};